// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"d45dc3a0","160":"c81385c7","208":"78f70799","293":"bef3a226","453":"e8dc896f","516":"c2c36c59","519":"3fd16738","917":"a829971a","946":"b2826ba3"}[chunkId] + ".chunk.js";
};